import { CartItem } from "./CartItem";

export default CartItem;